import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "../api/routes";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
  }),
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (phoneNumber) => {
        return {
          url: `/user/auth?phoneNumber=${phoneNumber}`,
          method: "get",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
        };
      },
    }),
    verifyUser: builder.mutation({
      query: (body) => {
        return {
          url: "/user/login/otp",
          method: "post",
          body,
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
        };
      },
    }),
  }),
});

export const { useLoginUserMutation, useVerifyUserMutation } = authApi;
